import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-56">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-57">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white text-charcoal rounded-sm max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-58">
            <div className="flex items-center justify-between p-6 border-b border-cream-dark sticky top-0 bg-white z-10" data-id="element-59">
              <h3 className="font-serif text-2xl" data-id="element-60">{title}</h3>
              <button onClick={onClose} className="p-2 hover:bg-cream rounded-full transition-colors" data-id="element-61">
                <XIcon className="w-5 h-5 text-charcoal-light" data-id="element-62" />
              </button>
            </div>
            <div className="p-6 text-charcoal-light leading-relaxed space-y-4" data-id="element-63">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-charcoal text-cream/60 py-12 border-t border-charcoal-light" data-id="element-64">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-65">
          <div className="text-center md:text-left" data-id="element-66">
            <h3 className="font-serif text-xl text-white mb-2" data-id="element-67">
              Rutina de Autocuidado para Pies Sensibles
            </h3>
            <p className="text-sm" data-id="element-68">
              © {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </div>

          <div className="flex items-center gap-4 text-sm" data-id="element-69">
            <span data-id="element-70">Producto digital</span>
            <span className="w-1 h-1 rounded-full bg-bronze" data-id="element-71" />
            <span data-id="element-72">PDF en español</span>
          </div>

          <div className="flex items-center gap-6 text-sm" data-id="element-73">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors underline underline-offset-4 decoration-cream/20 hover:decoration-white" data-id="element-74">
              Privacy Policy
            </button>
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors underline underline-offset-4 decoration-cream/20 hover:decoration-white" data-id="element-75">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-76">
        <p className="font-semibold text-charcoal" data-id="element-77">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-78">
          Esta política de privacidad describe cómo recopilamos, usamos y
          protegemos la información proporcionada al adquirir nuestros productos
          digitales.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-79">
          Información que recopilamos
        </h4>
        <p data-id="element-80">
          Al realizar una compra, podemos recopilar la siguiente información:
        </p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-81">
          <li data-id="element-82">Nombre completo</li>
          <li data-id="element-83">Dirección de correo electrónico</li>
          <li data-id="element-84">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-85">
          Uso de la información
        </h4>
        <p data-id="element-86">La información recopilada se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-87">
          <li data-id="element-88">Procesar y entregar tu compra digital</li>
          <li data-id="element-89">Enviar confirmaciones de pedido y acceso al producto</li>
          <li data-id="element-90">Brindar soporte relacionado con tu compra</li>
        </ul>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-91">
          Protección de datos
        </h4>
        <p data-id="element-92">
          No vendemos, compartimos ni transferimos tu información personal a
          terceros. Implementamos medidas de seguridad razonables para proteger
          tus datos.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-93">Cookies</h4>
        <p data-id="element-94">
          Nuestro sitio puede utilizar cookies para mejorar la experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies si lo
          prefieres.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-95">Tus derechos</h4>
        <p data-id="element-96">
          Tienes derecho a solicitar acceso, corrección o eliminación de tus
          datos personales en cualquier momento.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-97">
        <p className="font-semibold text-charcoal" data-id="element-98">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-99">
          Al adquirir este producto digital, aceptas los siguientes términos y
          condiciones.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-100">
          Producto digital
        </h4>
        <p data-id="element-101">
          Este es un producto 100% digital en formato PDF. No se realiza envío
          de productos físicos. El acceso al archivo se proporciona de forma
          inmediata después de completar la compra.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-102">Uso personal</h4>
        <p data-id="element-103">
          El contenido de esta guía es para uso personal y privado. Queda
          prohibida su reproducción, distribución, reventa o compartición total
          o parcial sin autorización previa por escrito.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-104">
          Naturaleza del contenido
        </h4>
        <p data-id="element-105">
          Esta guía es un recurso educativo de autocuidado general. No
          constituye asesoramiento médico, profesional ni personalizado. No
          sustituye la consulta con un profesional de la salud.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-106">
          Política de reembolso
        </h4>
        <p data-id="element-107">
          Debido a la naturaleza digital del producto y su entrega inmediata, no
          se aceptan devoluciones ni reembolsos una vez completada la descarga.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-108">
          Propiedad intelectual
        </h4>
        <p data-id="element-109">
          Todo el contenido, diseño y estructura de esta guía están protegidos
          por derechos de autor. Todos los derechos reservados.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-110">
          Modificaciones
        </h4>
        <p data-id="element-111">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </Modal>
    </>;
}